import styled from 'styled-components'

export const StyledLanguageSwitcher = styled.div`
  flex: 1;
  justify-content: flex-end;
  padding: 0 25px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

`
